import { ComponentProps } from "react";

export enum ICON_SIZE {
  LARGE = "large",
  MEDIUM = "medium",
  SMALL = "small",
}
export enum ICON_COLOR {
  DEFAULT = "default",
  BRAND = "brand",
  ACCENT = "accent",
  DANGER = "danger",
  SUCCESS = "success",
  WARNING = "warning",
  INFO = "info",
}

export enum ICON_VARIANT {
  DEFAULT = "default",
  LIGHT = "light",
  OUTLINE = "outline",
}

export type IconButtonProps = ComponentProps<"button"> & {
  icon: React.ReactElement;
  children?: React.ReactNode;
  variant?: ICON_VARIANT;
  color?: ICON_COLOR;
  size?: ICON_SIZE;
  message?: string;
  iconClassName?: string;
  hideTooltip?: boolean;
};
